import type { Currency } from '@/shared/api/types'
import { BtcIcon, GramIcon, LtcIcon, UsdtIcon, XmrIcon } from './icons'

/*
  Логотип монеты по валюте API.

  Живёт в ui, а не в shared/lib/currencies: там чистые данные, и тащить
  в них JSX незачем. Здесь же одно место, где валюта превращается
  в картинку, — значит новая монета не разъедется по экранам разными
  значками.
*/
const ICON = {
  btc: BtcIcon,
  ltc: LtcIcon,
  xmr: XmrIcon,
  gram: GramIcon,
  usdt_trc20: UsdtIcon,
  usdt_ton: UsdtIcon,
} as const satisfies Record<Currency, (p: { size?: number }) => unknown>

interface Props {
  currency: Currency
  size?: number
}

export function CoinIcon({ currency, size = 32 }: Props) {
  const Icon = ICON[currency]
  return <Icon size={size} />
}
